import React, { Fragment } from 'react';
import ReactMarkdown from 'react-markdown';
import { object, number, oneOfType, bool } from 'prop-types';
import { ifElse, has, prop, identity, pipe, invoker, split, defaultTo } from 'ramda';
import styled from 'styled-components';
import Price from './Price';

const InstallmentInformation = styled(ReactMarkdown)`
  font-family: Nunito Sans;
  font-weight: normal;
  line-height: 16px;
  text-align: center;
  color: #999999;
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 8px;
`;

const SpotPriceInformation = styled.span`
  font-family: Nunito Sans;
  font-weight: normal;
  line-height: 16px;
  text-align: center;
  color: #999999;
  font-size: 14px;
  margin-bottom: 5px;
  ${({ lineThrough }) => lineThrough && 'text-decoration: line-through;'}
`;
const getPrice = ifElse(
  has('previous'),
  prop('previous'),
  identity,
);
const splitPrice = pipe(
  getPrice,
  defaultTo(0),
  invoker(1, 'toFixed')(2),
  split('.'),
);
const InformationWrapper = styled.div`
  margin-top: 9px;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  flex-direction: column;
  ${({ discount }) => discount && 'margin: 17px 0px !important;'}
`;
const NormalText = styled.span`
    margin: 0 1px;
    font-size: 16px;
    color: #4a4a4a;
    line-height: 1.38;
`;
const HighlitedText = styled(NormalText)`
  font-size: 36px;
  line-height: 1;
`;
const getInstallmentValue = (value, maxInstallments) => (Math.floor((value / maxInstallments) * 100) / 100);

const InstallmentPrice = ({
  value = 0.00, posDiscount, visible, installment,
}) => {
  const { maxInstallments } = installment;

  if (typeof value === 'object') {
    const [spotIntPart, spotFloatPart] = splitPrice(value.current);
    const [previousIntPart, previousFloatPart] = splitPrice(value.previous);
    const installmentValue = getInstallmentValue(value.current, maxInstallments);
    const [installmentCurrentIntPart, installmentCurrentFloatPart] = splitPrice(installmentValue);
    return (
      <Fragment>
        <InstallmentInformation source={`${maxInstallments}x sem juros de`} />
        <InformationWrapper visible={visible}>
          <div>
            <NormalText>R$</NormalText>
            <HighlitedText>{installmentCurrentIntPart}</HighlitedText>
            <NormalText>,{installmentCurrentFloatPart}</NormalText>
          </div>
        </InformationWrapper>
        <InformationWrapper visible={visible}>
          <div>
            <SpotPriceInformation>ou R$ </SpotPriceInformation>
            <SpotPriceInformation lineThrough>{previousIntPart},{previousFloatPart}</SpotPriceInformation>
            <SpotPriceInformation> {spotIntPart},{spotFloatPart} à vista</SpotPriceInformation>
          </div>
        </InformationWrapper>
      </Fragment>
    );
  }

  const [spotIntPart, spotFloatPart] = splitPrice(value);
  const installmentValue = getInstallmentValue(value, maxInstallments);
  return (
    <Fragment>
      <InstallmentInformation source={`${maxInstallments}x sem juros de`} />
      <Price value={installmentValue} posDiscount={posDiscount} visible={visible} />
      <InformationWrapper visible={visible}>
        <div>
          <SpotPriceInformation>ou R$ {spotIntPart},{spotFloatPart} à vista</SpotPriceInformation>
        </div>
      </InformationWrapper>
    </Fragment>
  );
};

InstallmentPrice.propTypes = {
  value: oneOfType([object, number]).isRequired,
  posDiscount: number,
  visible: bool,
  installment: object,
};

InstallmentPrice.defaultProps = {
  visible: true,
  installment: { maxInstallments: 3 },
  posDiscount: 0,
};

export default InstallmentPrice;
